// TODO: This is a temporary fix to be replaced with a validation API
export function validateQuoteCharges(quote: any): boolean {
  // Check if any trip has charges with null chargeTypeId or chargeType
  const hasInvalidCharge = quote.trips?.some(trip => {
    // Ensure charges array exists and is not null
    if (!trip.charges || !Array.isArray(trip.charges)) {
      return false
    }

    return trip.charges.some(charge => {
      // Ensure charge itself is not null
      if (charge == null) {
        return true
      }

      // Check chargeTypeId is non-null
      if (charge.chargeTypeId == null) {
        return true
      }

      // Check chargeType object exists and has a valid id property
      if (charge.chargeType == null || charge.chargeType.id == null) {
        return true
      }

      return false
    })
  })

  return !hasInvalidCharge
}

// TODO: This is a temporary fix to be replaced with a validation API
export function validateQuoteStops(quote: any): boolean {
  // Check if any trip is missing required dates on first/last stops
  const hasInvalidStop = quote.trips?.some(trip => {
    // Ensure stops array exists and is not null
    if (!trip.stops || !Array.isArray(trip.stops)) {
      return true
    }

    // Need at least 2 stops
    if (trip.stops.length < 2) {
      return true
    }

    const firstStop = trip.stops[0]
    const lastStop = trip.stops[trip.stops.length - 1]

    // First stop must have a pickupDate
    if (!firstStop?.pickupDate) {
      return true
    }

    // Last stop must have a dropoffDate
    if (!lastStop?.dropoffDate) {
      return true
    }

    return false
  })

  return !hasInvalidStop
}
